/**
 * スクロールアニメーション
 */
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

interface HTMLElementWithTween extends HTMLElement {
  tween?: unknown;
}

export const scrollAnimation = {
  init: (): void => {
    const trigger = document.querySelectorAll<HTMLElement>('[data-inview]');
    trigger.forEach((tgt, i) => {
      gsap.fromTo(
        trigger[i],
        {
          opacity: 0,
          y: 5,
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          scrollTrigger: {
            trigger: trigger[i],
            start: 'top bottom',
          },
          onComplete: () => {
            // 初期非表示用 CSS（html.js-inview [data-inview]:not(.is-inview)）を解除する
            tgt.classList.add('is-inview');
            // memo:1のままだとターゲット要素のhover（opacity）が効かなくなるので空にする
            tgt.style.opacity = '';
            if (tgt === document.querySelector('.contact__fixed')) {
              scrollAnimation.fixedButtonsInit();
            }
          },
        }
      );
    });
  },
  fixedButtonsInit: (): void => {
    const fixedButton = document.querySelector<HTMLElementWithTween>(
      '.contact__fixed'
    );
    if (!fixedButton) return;

    let isFixed = false;
    const footer = document.querySelector<HTMLElement>('.footer');

    window.addEventListener('scroll', () => {
      if (!footer) return;

      const footerHeight = footer.offsetTop;
      const contactTop =
        document.documentElement.scrollTop + fixedButton.offsetTop;

      if (contactTop > footerHeight - 100) {
        if (isFixed) {
          if (fixedButton.tween) return;
          gsap.to(
            fixedButton,
            {
              opacity: 0,
              y: 0,
              duration: 0.3,
              ease: 'power2.inOut',
              onComplete: () => {
                fixedButton.style.visibility = 'hidden';
                isFixed = false;
              },
            }
          );
        }
      } else {
        if (!isFixed) {
          if (fixedButton.tween) return;
          fixedButton.style.visibility = 'visible';
          gsap.to(
            fixedButton,
            {
              opacity: 1,
              y: 0,
              duration: 0.3,
              ease: 'power2.inOut',
              onComplete: () => {
                isFixed = true;
              },
            }
          );
        }
      }
    });
  },
};
